<template>
  <section>
    <h2>Offre d'emploi</h2>
    <div
      class="d-flex align-items-center justify-content-around my-4 row no-gutters"
    >
      <!-- Interne -->
      <div
        class="col-3 col-sm-2 order-2 d-flex flex-column justify-content-between align-items-center my-2 my-sm-0"
      >
        <button
          @click="modalOffre = !modalOffre"
          type="button"
          class="btn btn-success btn_repertoire"
        >
          <font-awesome-icon icon="clipboard-list" size="2x" />
        </button>
        <span class="text-success span_repertoire">Interne</span>
        <b-modal
          v-model="modalOffre"
          size="xl"
          centered
          ok-only
          scrollable
          title="Recrutement interne"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/bourse%20%c3%a0%20l'emploi/Recrutement%20interne%20-%20T%c3%a9l%c3%a9conseiller.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      modalOffre: false
    };
  }
};
</script>
